import OrdersGlovo from '../OrdersGlovo';

export default OrdersGlovo;
